// Header
$(document).ready(function () {
  $(".header-new-menu-btn").click(function () {
    $(".header-new-menus").toggleClass("open");
    $('.header-new-cart-drawer').removeClass('open')
  });

  $(document).click(function (event) {
    if (!$(event.target).closest('.header-new-container').length) {
      $('.header-new-menus').removeClass('open');
      $('.header-new-cart-drawer').removeClass('open');
    }
  });

  if (window.innerWidth <= 749 && !$(".template-bg").hasClass("delivery") ) {
    $('details').removeAttr('open');
    $('summary').removeAttr('aria-expanded');
  }

  // $(".custom-notify-klaviyo-bis-trigger").click(function () {
  //   window._klOnsite = window._klOnsite || [];
  //   window._klOnsite.push(['openForm', 'YAiGG3']);
  // });

$(".custom-notify-klaviyo-bis-trigger").click(function () {
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', 'YAiGG3']);
  
  setTimeout(function() {
    var inputField = $('.klaviyo-form').find('input[placeholder="Product Handel"]');
    var targetValue = window.location.pathname;
    
    function ensureValue() {
      if (inputField.val() !== targetValue) {
        inputField.val(targetValue);
        inputField.prop('readonly', true);
      }
    }

    // Set the initial value and make it read-only
    ensureValue();
    
    // Keep checking and setting the value
    var intervalId = setInterval(ensureValue, 100);

  }, 500);
});

const quantityEl = document.querySelector('.featured-product-button-quantity');
const usaTextEl = document.querySelector('.only-for-usa-text');

if (quantityEl && usaTextEl) {
  const quantityParent = quantityEl.parentElement;

  // Move the USA text before the quantity button
  quantityParent.insertBefore(usaTextEl, quantityEl);
}
  
});

// Featured Product Slider
// $(document).ready(function () {
//   $('.featured-product-slides-1').slick({
//     arrows: false,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     fade: true,
//     cssEase: 'linear',
//     draggable: false,
//     touchMove: false,
//     swipe: false,
//     prevArrow: '<button type="button" class="featured-product-slider-btn-prev" data-role="none" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="21" viewBox="0 0 28 21" fill="none"><path d="M27.3334 10.2358C27.3334 10.937 26.7365 11.5054 26.0001 11.5054H4.89341L11.0134 18.298C11.4921 18.8309 11.4264 19.6324 10.8667 20.0882C10.3071 20.544 9.46539 20.4814 8.98675 19.9485L0.986748 11.0611C0.938983 10.9978 0.898737 10.9296 0.866748 10.8579C0.826617 10.8102 0.790927 10.7592 0.760081 10.7056C0.702308 10.5549 0.670782 10.3962 0.666748 10.2358C0.670782 10.0754 0.702308 9.91673 0.760081 9.76603C0.790927 9.71239 0.826617 9.66141 0.866748 9.61367C0.898737 9.54194 0.938983 9.47381 0.986748 9.41053L8.98675 0.523073C9.46539 -0.00983949 10.3071 -0.0723674 10.8667 0.383413C11.4264 0.839194 11.4921 1.64069 11.0134 2.1736L4.89341 8.96616H26.0001C26.7365 8.96616 27.3334 9.53459 27.3334 10.2358Z" fill="#231F20"/></svg></button>',
//     nextArrow: '<button type="button" class="featured-product-slider-btn-next" data-role="none" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="21" viewBox="0 0 28 21" fill="none"><path d="M0.666586 10.7642C0.666586 10.063 1.26354 9.49457 1.99992 9.49457H23.1066L16.9866 2.70201C16.5079 2.1691 16.5736 1.36761 17.1333 0.911825C17.6929 0.456045 18.5346 0.518574 19.0133 1.05149L27.0133 9.93894C27.061 10.0022 27.1013 10.0704 27.1333 10.1421C27.1734 10.1898 27.2091 10.2408 27.2399 10.2944C27.2977 10.4451 27.3292 10.6038 27.3333 10.7642C27.3292 10.9246 27.2977 11.0833 27.2399 11.234C27.2091 11.2876 27.1734 11.3386 27.1333 11.3863C27.1013 11.4581 27.061 11.5262 27.0133 11.5895L19.0133 20.4769C18.5346 21.0098 17.6929 21.0724 17.1333 20.6166C16.5736 20.1608 16.5079 19.3593 16.9866 18.8264L23.1066 12.0338H1.99992C1.26354 12.0338 0.666586 11.4654 0.666586 10.7642Z" fill="#231F20"/></svg></button>',
//     responsive: [
//       {
//         breakpoint: 749,
//         settings: {
//           arrows: true
//         }
//       }
//     ]
//   });
//   $('.featured-product-thumbnails-1').slick({
//     arrows: true,
//     speed: 300,
//     centerMode: true,
//     focusOnSelect: true,
//     slidesToShow: 5,
//     slidesToScroll: 1,
//     variableWidth: true,
//     asNavFor: '.featured-product-slides-1',
//     prevArrow: '<button type="button" class="featured-product-slider-btn-prev" data-role="none" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="21" viewBox="0 0 28 21" fill="none"><path d="M27.3334 10.2358C27.3334 10.937 26.7365 11.5054 26.0001 11.5054H4.89341L11.0134 18.298C11.4921 18.8309 11.4264 19.6324 10.8667 20.0882C10.3071 20.544 9.46539 20.4814 8.98675 19.9485L0.986748 11.0611C0.938983 10.9978 0.898737 10.9296 0.866748 10.8579C0.826617 10.8102 0.790927 10.7592 0.760081 10.7056C0.702308 10.5549 0.670782 10.3962 0.666748 10.2358C0.670782 10.0754 0.702308 9.91673 0.760081 9.76603C0.790927 9.71239 0.826617 9.66141 0.866748 9.61367C0.898737 9.54194 0.938983 9.47381 0.986748 9.41053L8.98675 0.523073C9.46539 -0.00983949 10.3071 -0.0723674 10.8667 0.383413C11.4264 0.839194 11.4921 1.64069 11.0134 2.1736L4.89341 8.96616H26.0001C26.7365 8.96616 27.3334 9.53459 27.3334 10.2358Z" fill="#231F20"/></svg></button>',
//     nextArrow: '<button type="button" class="featured-product-slider-btn-next" data-role="none" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="21" viewBox="0 0 28 21" fill="none"><path d="M0.666586 10.7642C0.666586 10.063 1.26354 9.49457 1.99992 9.49457H23.1066L16.9866 2.70201C16.5079 2.1691 16.5736 1.36761 17.1333 0.911825C17.6929 0.456045 18.5346 0.518574 19.0133 1.05149L27.0133 9.93894C27.061 10.0022 27.1013 10.0704 27.1333 10.1421C27.1734 10.1898 27.2091 10.2408 27.2399 10.2944C27.2977 10.4451 27.3292 10.6038 27.3333 10.7642C27.3292 10.9246 27.2977 11.0833 27.2399 11.234C27.2091 11.2876 27.1734 11.3386 27.1333 11.3863C27.1013 11.4581 27.061 11.5262 27.0133 11.5895L19.0133 20.4769C18.5346 21.0098 17.6929 21.0724 17.1333 20.6166C16.5736 20.1608 16.5079 19.3593 16.9866 18.8264L23.1066 12.0338H1.99992C1.26354 12.0338 0.666586 11.4654 0.666586 10.7642Z" fill="#231F20"/></svg></button>',
//     responsive: [
//       {
//         breakpoint: 749,
//         settings: {
//           slidesToShow: 1,
//           arrows: false
//         }
//       }
//     ]
//   });

//   $(".featured-product-thumbnails-1").addClass("active")

//   // For 2nd Slider
//   $('.featured-product-slides-2').slick({
//     arrows: false,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     fade: true,
//     draggable: false,
//     touchMove: false,
//     swipe: false,
//     prevArrow: '<button type="button" class="featured-product-slider-btn-prev" data-role="none" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="21" viewBox="0 0 28 21" fill="none"><path d="M27.3334 10.2358C27.3334 10.937 26.7365 11.5054 26.0001 11.5054H4.89341L11.0134 18.298C11.4921 18.8309 11.4264 19.6324 10.8667 20.0882C10.3071 20.544 9.46539 20.4814 8.98675 19.9485L0.986748 11.0611C0.938983 10.9978 0.898737 10.9296 0.866748 10.8579C0.826617 10.8102 0.790927 10.7592 0.760081 10.7056C0.702308 10.5549 0.670782 10.3962 0.666748 10.2358C0.670782 10.0754 0.702308 9.91673 0.760081 9.76603C0.790927 9.71239 0.826617 9.66141 0.866748 9.61367C0.898737 9.54194 0.938983 9.47381 0.986748 9.41053L8.98675 0.523073C9.46539 -0.00983949 10.3071 -0.0723674 10.8667 0.383413C11.4264 0.839194 11.4921 1.64069 11.0134 2.1736L4.89341 8.96616H26.0001C26.7365 8.96616 27.3334 9.53459 27.3334 10.2358Z" fill="#231F20"/></svg></button>',
//     nextArrow: '<button type="button" class="featured-product-slider-btn-next" data-role="none" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="21" viewBox="0 0 28 21" fill="none"><path d="M0.666586 10.7642C0.666586 10.063 1.26354 9.49457 1.99992 9.49457H23.1066L16.9866 2.70201C16.5079 2.1691 16.5736 1.36761 17.1333 0.911825C17.6929 0.456045 18.5346 0.518574 19.0133 1.05149L27.0133 9.93894C27.061 10.0022 27.1013 10.0704 27.1333 10.1421C27.1734 10.1898 27.2091 10.2408 27.2399 10.2944C27.2977 10.4451 27.3292 10.6038 27.3333 10.7642C27.3292 10.9246 27.2977 11.0833 27.2399 11.234C27.2091 11.2876 27.1734 11.3386 27.1333 11.3863C27.1013 11.4581 27.061 11.5262 27.0133 11.5895L19.0133 20.4769C18.5346 21.0098 17.6929 21.0724 17.1333 20.6166C16.5736 20.1608 16.5079 19.3593 16.9866 18.8264L23.1066 12.0338H1.99992C1.26354 12.0338 0.666586 11.4654 0.666586 10.7642Z" fill="#231F20"/></svg></button>',
//     responsive: [
//       {
//         breakpoint: 749,
//         settings: {
//           arrows: true
//         }
//       }
//     ]
//   });
//   $('.featured-product-thumbnails-2').slick({
//     arrows: true,
//     speed: 300,
//     centerMode: true,
//     focusOnSelect: true,
//     slidesToShow: 5,
//     slidesToScroll: 1,
//     variableWidth: true,
//     asNavFor: '.featured-product-slides-2',
//     prevArrow: '<button type="button" class="featured-product-slider-btn-prev" data-role="none" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="21" viewBox="0 0 28 21" fill="none"><path d="M27.3334 10.2358C27.3334 10.937 26.7365 11.5054 26.0001 11.5054H4.89341L11.0134 18.298C11.4921 18.8309 11.4264 19.6324 10.8667 20.0882C10.3071 20.544 9.46539 20.4814 8.98675 19.9485L0.986748 11.0611C0.938983 10.9978 0.898737 10.9296 0.866748 10.8579C0.826617 10.8102 0.790927 10.7592 0.760081 10.7056C0.702308 10.5549 0.670782 10.3962 0.666748 10.2358C0.670782 10.0754 0.702308 9.91673 0.760081 9.76603C0.790927 9.71239 0.826617 9.66141 0.866748 9.61367C0.898737 9.54194 0.938983 9.47381 0.986748 9.41053L8.98675 0.523073C9.46539 -0.00983949 10.3071 -0.0723674 10.8667 0.383413C11.4264 0.839194 11.4921 1.64069 11.0134 2.1736L4.89341 8.96616H26.0001C26.7365 8.96616 27.3334 9.53459 27.3334 10.2358Z" fill="#231F20"/></svg></button>',
//     nextArrow: '<button type="button" class="featured-product-slider-btn-next" data-role="none" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="21" viewBox="0 0 28 21" fill="none"><path d="M0.666586 10.7642C0.666586 10.063 1.26354 9.49457 1.99992 9.49457H23.1066L16.9866 2.70201C16.5079 2.1691 16.5736 1.36761 17.1333 0.911825C17.6929 0.456045 18.5346 0.518574 19.0133 1.05149L27.0133 9.93894C27.061 10.0022 27.1013 10.0704 27.1333 10.1421C27.1734 10.1898 27.2091 10.2408 27.2399 10.2944C27.2977 10.4451 27.3292 10.6038 27.3333 10.7642C27.3292 10.9246 27.2977 11.0833 27.2399 11.234C27.2091 11.2876 27.1734 11.3386 27.1333 11.3863C27.1013 11.4581 27.061 11.5262 27.0133 11.5895L19.0133 20.4769C18.5346 21.0098 17.6929 21.0724 17.1333 20.6166C16.5736 20.1608 16.5079 19.3593 16.9866 18.8264L23.1066 12.0338H1.99992C1.26354 12.0338 0.666586 11.4654 0.666586 10.7642Z" fill="#231F20"/></svg></button>',
//     responsive: [
//       {
//         breakpoint: 749,
//         settings: {
//           slidesToShow: 1,
//           arrows: false
//         }
//       }
//     ]
//   });
// });

// redesign slider
$(document).ready(function () {
    $('.featured-product-slider__pr-tab .tab-name').on('click',function(){
      $(".featured-product-thumbnails-1").slick('setPosition');
      $(".featured-product-slides-1").slick('setPosition');

      $(".featured-product-thumbnails-2").slick('setPosition');
      $(".featured-product-slides-2").slick('setPosition');
    });

    // Function to reset image sources to their original
    function resetImageSources(containerClass) {
        $(containerClass + ' .hw__featured-pro-thumb > img').each(function() {
            $(this).attr('src', $(this).data('original'));
        });
    }

    // Function to update gif source for a given image element
    function updateGifSource($imgElement) {
        var gifSrc = $imgElement.data('gif');
        if (gifSrc) {
            $imgElement.attr('src', gifSrc);
        }
    }

    // Event handler for clicking on a featured product thumbnail
    $('.featured-product-thumbnail').on('click', function () {
        var containerClass = $(this).closest('[data-container-class]').data('container-class');
        
        resetImageSources(containerClass);

        var $img = $(this).find('img');
        updateGifSource($img);

        var $centerImg = $(containerClass + ' .featured-product-thumbnails .slick-center').find('img');
        if ($centerImg.data('gif')) {
            updateGifSource($centerImg);
        }
    });

    // Initialize gif source for the center thumbnail on page load
    $('[data-container-class]').each(function() {
        var containerClass = $(this).data('container-class');
        var $centerImg = $(containerClass + ' .featured-product-thumbnails .slick-center').find('img');
        if ($centerImg.data('gif')) {
            updateGifSource($centerImg);
        }

        // Initialize the main slider
        $(containerClass + ' .hw__featured-product--slider').slick({
            slidesToShow: 1,
            infinite: false,
            asNavFor: containerClass + ' .hw__thumbnail-list',
        });

        // Update slider position on tab click
        $('.tab-name').on('click',function(){
          $('.hw__featured-product--slider').slick('setPosition');
          $(".hw__thumbnail-list").slick('setPosition');
        });

        // Initialize the thumbnail list slider
        $(containerClass + ' .hw__thumbnail-list').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            vertical: true,
            verticalSwiping: true,
            asNavFor: containerClass + ' .hw__featured-product--slider',
            focusOnSelect: true,
            infinite: false,
            arrows: false,
            dots: false,
            responsive: [
              {
                breakpoint: 1252,
                settings: {
                  slidesToShow: 5,
                  slidesToScroll: 1,
                  vertical: false,
                  verticalSwiping: false,
                }
              },
            ]
        });

        // Event handler for clicking on a thumbnail list item
        $(containerClass + ' .hw__thumbnail-list--item').on('click', function () {
            $(containerClass + ' .hw__thumbnail-list--item').removeClass('active');
            $(this).addClass('active');
            var mediaId = $(this).data('media-id');
            $(containerClass + ' .hw__featured-product--slider').slick('slickGoTo', mediaId);
        });

        // Update active thumbnail list item after slide change
        $(containerClass + ' .hw__featured-product--slider').on('afterChange', function (event, slick, currentSlide) {
            $(containerClass + ' .hw__thumbnail-list--item').removeClass('active');
            $(containerClass + ' .hw__thumbnail-list--item[data-media-id="' + currentSlide + '"]').addClass('active');
        });
    });
});

//end redesign slider
//Image pop-up

$(function () {
  "use strict";

  $(".popup img").click(function () {
    var $src = $(this).attr("src");
    $(".show").fadeIn();
    $(".img-show img").attr("src", $src);
  });

  $("span, .overlay").click(function () {
    $(".show").fadeOut();
  });

});

const div_s = document.querySelectorAll('div[id="dynamic-count-hw_hw"]');

div_s.forEach(div => {
    if (div.innerText.trim() == "") {
        div.className = "dynamic-count dynamic-count-slider"; // Remove all classes
    } else {
        div.className = "featured-product-count dynamic-count dynamic-count-slider"; // Add all classes
    }
});

const div__s = document.querySelectorAll('div[id="dynamic-count-hw"]');

div__s.forEach(div => {
    if (div.innerHTML.trim() === "") {
        div.className = "dynamic-count dynamic-count-slider"; // Remove all classes
    } else {
        div.className = "redesign-collection-product-count dynamic-count dynamic-count-slider"; // Add all classes
    }
});
